import { Button } from '../v3/button';

// Clears every selected filter. Drawn like the HeaderBar Filter button (the same v3 ghost Button and
// colours, see .reset-all-button in filter.scss) so the two read as one control set.
const ResetButton = props => (
  <Button variant="ghost" className="reset-all-button" {...props}>
    Reset
  </Button>
);

export default ResetButton;
